import { getTopicReports } from "./topic-api"
import { getDimensionReports } from "./dimension-api"

export const getReportsList = (token, parameters) => {
    if (parameters.get("topic")) {
        const parametersWithoutTopic = parameters.remove("topic")
        return getTopicReports(
            token,
            parameters.get("topic"),
            parametersWithoutTopic
        )
    } else if (parameters.get("dimension")) {
        const parametersWithoutDimension = parameters.remove("dimension")
        return getDimensionReports(
            token,
            parameters.get("dimension"),
            parametersWithoutDimension
        )
    } else {
        throw new Error("Can only be used for topics and dimensions")
    }
}
